import { render, staticRenderFns } from "./ItemFilterRealSaleFilter.vue?vue&type=template&id=82b70a5c&scoped=true"
import script from "./ItemFilterRealSaleFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterRealSaleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b70a5c",
  null
  
)

export default component.exports